import { render, staticRenderFns } from "./templateTargetWeight.vue?vue&type=template&id=2a3054e0&scoped=true"
import script from "./templateTargetWeight.vue?vue&type=script&lang=js"
export * from "./templateTargetWeight.vue?vue&type=script&lang=js"
import style0 from "./templateTargetWeight.vue?vue&type=style&index=0&id=2a3054e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3054e0",
  null
  
)

export default component.exports